// extracted by mini-css-extract-plugin
module.exports = {"popover":"wishlist-button_popover__g7GD7"};